import React from 'react';

import {CircularProgress, Stack} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";


class MessageSticker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sticker: null,
        }
    }

    async componentDidMount() {
        await this.retrieveContent()
    }

    async retrieveContent(){
        const url = `sticker/${this.props.message.content}/`;
        const api = new BaseApi();
        let params = {};
        let response = await api.get(
            url,
            params
        );
        this.setState({
            sticker: response.data
        })
    }

    render() {
        if (!this.state.sticker) {
            return (
                <CircularProgress/>
            )
        }
        return (
            <Stack>
                <img
                    src={`data:image/png;base64,${this.state.sticker.content}`}
                    loading="lazy"
                    alt={this.state.sticker.description}
                    style={{
                        maxWidth: '300px',
                        borderRadius: '16px',
                        cursor: 'pointer',
                    }}
                />
            </Stack>
        )
    }
}

export default MessageSticker
